<template>
  <div class="grid-drawer-form">
    <drawer
      :title="title"
      v-model="visible"
      :width="'auto'"
      @on-close="handleClose"
      :maskStyle="drawerStyle"
      :wrapperStyle="drawerStyle"
      :mainStyle="drawerStyle"
    >
      <component :is="formCmp"
                 v-if="formCmp !== ''"
                 ref="myForm"
                 :formConfig="formConfig"
                 :showHeader="false"
                 :showFooter="false"
                 @submit-start="submitStart"
                 @submit-success="submitSuccess"
                 @submit-error="submitError"
                 @change-router="handleChangeRouter"
      ></component>
      <div class="popup-foot">
        <a href="javascript:" class="btn btn-solid" @click="handleSubmit">提交</a>
        <a href="javascript:" class="btn btn-hollow" @click="handleCancel">取消</a>
      </div>
    </drawer>
  </div>
</template>
<script>
  import Drawer from '../drawer/drawer'
  // import CommonForm from './common-form'
  export default {
    name: 'drawer-form',
    // components: {CommonForm, Drawer},
    components: {Drawer},
    props: {
      formConfig: {
        type: Object,
        default() {
          return {}
        }
      },
      formCmpName: {
        type: String
      }
    },
    data() {
      return {
        visible: false
      }
    },
    computed: {
      title: function () {
        return this.formConfig.title || ''
      },
      drawerStyle: function () {
        return {
          left: (this.$store.state.app.showLeftMenu ? 251 : 0) + 'px'
        }
      },
      formCmp: function () {
        if (this.formCmpName) {
          let cmpName = this.formCmpName
          return require(`../../custom/components/grid-add-forms/${cmpName}.vue`).default
        }
        return require('./common-form.vue').default
      }
    },
    methods: {
      show() {
        this.visible = true
        this.resetForm()
      },
      hide() {
        this.visible = false
      },
      // 重置form表单
      resetForm() {
        if (this.$refs.myForm && this.$refs.myForm.resetForm) {
          this.$refs.myForm.resetForm()
        }
      },
      // drawer关闭时触发
      handleClose() {
        this.resetForm()
        this.$emit('close')
      },
      submitStart() {
        this.$emit('submit-start')
      },
      submitSuccess() {
        this.$emit('submit-success')
      },
      submitError() {
        this.$emit('submit-error')
      },
      handleChangeRouter(router) {
        this.$emit('change-router', router)
      },
      handleSubmit() {
        if (this.$refs.myForm && this.$refs.myForm.handleSubmit) {
          this.$refs.myForm.handleSubmit()
        } else {
          console.warn('submit方法未定义')
        }
      },
      handleCancel() {
        this.hide()
      }
    }
  }
</script>
<style lang="scss">
  .grid-drawer-form {
    .ivu-drawer-mask, .ivu-drawer-wrap, .ivu-drawer {
      top: 60px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/grid/drawer-form.vue